
// collections-slider.js
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    // Inicjalizacja głównych sliderów kolekcji
    initCollectionSliders();

    // Inicjalizacja sliderów galerii w kolekcjach
    initCollectionGallerySliders();

    // Inicjalizacja sliderów produktów wewnątrz kolekcji
    initCollectionProductSliders();
});

/**
 * Inicjalizacja głównych sliderów kolekcji
 */
function initCollectionSliders() {
    const collectionSliderContainers = document.querySelectorAll('[data-collection-slider-container]');

    if (collectionSliderContainers.length === 0) return;

    collectionSliderContainers.forEach((container) => {
        const containerId = container.getAttribute('data-collection-slider-container');
        const imageSlider = container.querySelector('[data-collection-image-slider-id="' + containerId + '"]');
        const prevButton = container.querySelector('[data-collection-slider-prev="' + containerId + '"]');
        const nextButton = container.querySelector('[data-collection-slider-next="' + containerId + '"]');

        if (!imageSlider || !prevButton || !nextButton) {
            console.warn(`Collection slider elements not found for: ${containerId}`);
            return;
        }

        new Swiper(imageSlider, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 600,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
        });
    });
}

/**
 * Inicjalizacja sliderów galerii obrazów w kolekcjach
 */
function initCollectionGallerySliders() {
    const galleryContainers = document.querySelectorAll('[data-collection-gallery-container]');

    if (galleryContainers.length === 0) return;

    galleryContainers.forEach((container) => {
        const galleryId = container.getAttribute('data-collection-gallery-container');
        const gallerySlider = container.querySelector('[data-collection-gallery-slider="' + galleryId + '"]');
        const prevButton = container.querySelector('[data-collection-gallery-prev="' + galleryId + '"]');
        const nextButton = container.querySelector('[data-collection-gallery-next="' + galleryId + '"]');

        if (!gallerySlider || !prevButton || !nextButton) {
            console.warn(`Gallery slider elements not found for: ${galleryId}`);
            return;
        }

        // Sprawdź czy jest więcej niż 1 slajd
        const slides = gallerySlider.querySelectorAll('.swiper-slide');
        if (slides.length <= 1) {
            // Ukryj nawigację jeśli jest tylko 1 zdjęcie
            prevButton.style.display = 'none';
            nextButton.style.display = 'none';
            return;
        }

        new Swiper(gallerySlider, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 400,
            loop: slides.length > 1,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
        });
    });
}

/**
 * Inicjalizacja sliderów produktów w kolekcjach
 * Slider aktywny tylko poniżej 968px, powyżej wyłączony (grid)
 */
function initCollectionProductSliders() {
    const productSliders = document.querySelectorAll('[data-collection-products-slider]');

    if (productSliders.length === 0) return;

    productSliders.forEach((sliderElement) => {
        const sliderId = sliderElement.getAttribute('data-collection-products-slider');
        const prevButton = document.querySelector('[data-prev-for="' + sliderId + '"]');
        const nextButton = document.querySelector('[data-next-for="' + sliderId + '"]');

        if (!prevButton || !nextButton) {
            console.warn(`Product slider navigation not found for: ${sliderId}`);
            return;
        }

        let swiperInstance = null;

        // Funkcja inicjalizująca Swiper
        function initSwiper() {
            if (window.innerWidth < 968 && !swiperInstance) {
                swiperInstance = new Swiper(sliderElement, {
                    modules: [Navigation],
                    slidesPerView: 2,
                    spaceBetween: 16,
                    speed: 400,
                    navigation: {
                        nextEl: nextButton,
                        prevEl: prevButton,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                    },
                });
            } else if (window.innerWidth >= 991 && swiperInstance) {
                // Zniszcz Swiper powyżej 968px
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        }

        // Inicjalizacja przy załadowaniu
        initSwiper();

        // Re-inicjalizacja przy zmianie rozmiaru okna
        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                initSwiper();
            }, 250);
        });
    });
}